import { render, staticRenderFns } from "./live-online.vue?vue&type=template&id=3afaedc6&scoped=true&"
import script from "./live-online.vue?vue&type=script&lang=js&"
export * from "./live-online.vue?vue&type=script&lang=js&"
import style0 from "./live-online.vue?vue&type=style&index=0&id=3afaedc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afaedc6",
  null
  
)

export default component.exports